$(function () {

  var accTrigger = $('.myaccount__order-history-heading');
  
  if (window.matchMedia('(max-width: 749px)').matches) {
	accTrigger.click(function(){
        $(this).toggleClass('open');
		$(this).siblings('.responsive-table').slideToggle();
     });
  }
  
  
  // fiexed header
  var headerHeight = $(".site-header").height();
  var header = $(".site-header");
  var navPos = header.offset().top;
  var navDown = $(".site-nav__dropdown");

  window.onload = function() {
    navDown.css("top", headerHeight);
  };

  $(window).resize(function() {
    var headerHeight = $(".site-header").height();
    navDown.css("top", headerHeight);
  });

  $(window).scroll(function(){
    var scrollTop = $(document).scrollTop();
    
    if(scrollTop > navPos) {
      header.addClass("header_fixed");
      $("body").css("padding-top", headerHeight)
    } else{
      header.removeClass("header_fixed");
      $("body").css("padding-top", "0")
    }
  })

  // anchor link
  $('a[href^="#"]').click(function(e) {
    var headerOuterHeight = $('.site-header').outerHeight() + 40;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - headerOuterHeight;

    $.when(
      $("html, body").animate({
        scrollTop: position
      }, 400, "swing"),
      e.preventDefault(),
    ).done(function() {
      var diff = target.offset().top - headerOuterHeight;
      if (diff === position) {
      } else {
        $("html, body").animate({
          scrollTop: diff
        }, 10, "swing");
      }
    });
  });

  // other page anchor link
  $(window).on('load', function() {
    var headerOuterHeight = $('.site-header').outerHeight();
    if(document.URL.match("#")) {
      var str = location.href ;
      var cut_str = "#";
      var index = str.indexOf(cut_str);
      var href = str.slice(index);
      var target = href;
      var position = $(target).offset().top - headerOuterHeight;
      $("html, body").animate({
        scrollTop: position
      }, 200, "swing")
      return false;
    }
  });

});